import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function BasetenIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="32" height="41" viewBox="0 0 32 41" fill="none" {...props}>
      <path
        d="M0.501004 8.49914H23.9989V16.4983H8.49993C8.22374 16.4983 7.99893 16.7231 7.99893 16.9993V23.9986C7.99893 24.2748 8.22374 24.4996 8.49993 24.4996H23.9989V32.4987H16.4989C16.2227 32.4987 15.9979 32.7235
        15.9979 32.9997V39.999C15.9979 40.2752 16.2227 40.5 16.4989 40.5H23.4979C23.7741 40.5 23.9989 40.2752 23.9989 39.999V32.4987H31.499C31.7752 32.4987 32 32.2739 32 31.9977V24.9984C32 24.7222 31.7752 24.4974
        31.499 24.4974H23.9989V16.4983H31.499C31.7752 16.4983 32 16.2735 32 15.9973V8.99802C32 8.72182 31.7752 8.497 31.499 8.497H23.9989V1.00102C23.9989 0.724815 23.7741 0.5 23.4979 0.5H0.501004C0.224809
        0.5 0 0.724815 0 1.00102V8.00027C0 8.27647 0.224809 8.50128 0.501004 8.50128V8.49914Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

export default BasetenIcon;
